/**
 * Antivirus scan holds, at the API layer so the HTTP client and features/
 * share one mapping.
 *
 * Whether a file is held is the server's decision (`scan_held` on media, or
 * `scan_held: true` on a 409). It is false whenever scanning is off, and a
 * copy follows its parent. `scan_status` only picks the label shown:
 *
 * - scanning: the check is still running; it clears on its own.
 * - review: the check couldn't finish; the file stays locked until reviewed.
 * - blocked: the check found something; the file stays locked.
 */
export type MediaScanHold = 'scanning' | 'review' | 'blocked';

/** The label for a file the server says is held. Unknown statuses read as scanning. */
export const scanHoldLabel = (status?: string | null): MediaScanHold => {
  switch (status) {
    case 'error':
      return 'review';
    case 'infected':
      return 'blocked';
    default:
      return 'scanning';
  }
};

export const SCAN_HOLD_TOAST_TITLE: Record<MediaScanHold, string> = {
  scanning: 'File still being scanned',
  review: 'File held for review',
  blocked: 'File blocked',
};
